export enum mpTrackingPopups {
    premiumPublisher = 'PremiumPublisher',
    authenticate = 'Authenticate',
    downloadApp = 'DownloadApp',
    cancelConfirm = 'CancelConfirm',
    freeAccessConfirmed = 'FreeAccessConfirmed',
}
